import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
/* Meta Pixel Code (official) */
;
(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
window.fbq('init', '2054642012133298');
window.fbq('track', 'PageView');
/* End Meta Pixel Code */
render(<App data-id="element-281" />, document.getElementById('root'));